import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { Dialog, Notify, Quasar } from 'quasar'
import { i18n, loadLocaleMessages } from 'js/vue/i18n'
import { lang, langRelation } from 'store/lang.store'
import { NotifyInit } from './boot/Notify'
import App from 'js/vue/App.vue'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import quasarEN from 'quasar/lang/en-US'
import quasarES from 'quasar/lang/es'
import quasarPT from 'quasar/lang/pt-BR'
import router from './router/router'

NotifyInit()

const context = {
  ...window.context,
}
const app = createApp(App)

;(async () => {
  app.provide('context', context)
  app.config.globalProperties.$console = console.log

  const language = {
    'pt-BR': quasarPT,
    'en-US': quasarEN,
    es: quasarES,
  }

  await loadLocaleMessages(langRelation)
  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)

  app.use(pinia)
  app.use(i18n)
  app.use(router)
  app.use(Quasar, {
    plugins: {
      Notify,
      Dialog,
    },

    lang: language[lang.value],
    config: {
      dark: false,
      notify: {},
      screen: {
        bodyClasses: true,
      },
      ripple: {
        early: true,
      },
    },
  })

  app.mount('#App')
})()

export default app
